import { connect } from "react-redux";
import AddCategory from "./AddCategory";
import { bindActionCreators } from "redux";
import { createDeleteCategory } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  categoryList: state.businessItemReducer.categoryList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createDeleteCategory,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddCategory);
